import Swiper from 'swiper';
import { Autoplay, Controller, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export function slider(rootDir = '') {
if (document.querySelector('.p-top')) {
  const pickupWrapper = document.querySelector('.js-pickup-slider .swiper-wrapper');
  let originalCount = 0;

  if (pickupWrapper) {
    const originalSlides = Array.from(pickupWrapper.querySelectorAll('.swiper-slide'));
    originalCount = originalSlides.length;

    [1, 2].forEach(() => {
      originalSlides.forEach(slide => {
        const clone = slide.cloneNode(true);
        pickupWrapper.appendChild(clone);
      });
    });
  }

  function updateBullets(swiper, count) {
    const bullets = document.querySelectorAll('.p-top-pickup .swiper-pagination .swiper-pagination-bullet');
    const realIndex = swiper.realIndex % count;
    bullets.forEach((bullet, i) => {
      bullet.classList.toggle('swiper-pagination-bullet-active', i === realIndex);
    });
  }

  const pickupSlider = new Swiper('.js-pickup-slider', {
    modules: [Controller, Navigation, Autoplay, Pagination],
    slidesPerView: 'auto',
    loop: true,
    loopedSlides: originalCount,
    speed: 800,
    allowTouchMove: true,
    centeredSlides: true,
    spaceBetween: 30,
    autoHeight: false,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    navigation: {
      prevEl: '.js-pickup-slider .js-swiper-button-prev',
      nextEl: '.js-pickup-slider .js-swiper-button-next',
    },
    pagination: {
      el: '.p-top-pickup .swiper-pagination',
      clickable: true,
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        // bullet要素を生成（originalCount分のみ）
        let html = '';
        const realIndex = swiper.realIndex % originalCount;
        for (let i = 0; i < originalCount; i++) {
          const activeClass = i === realIndex ? ' swiper-pagination-bullet-active' : '';
          html += `<span class="swiper-pagination-bullet${activeClass}" data-index="${i}"></span>`;
        }
        return html;
      },
    },
    on: {
      init: function () {
        // clickable対応：bullet再生成後にクリックイベントを手動付与
        bindBulletClicks(this, originalCount);
      },
      paginationRender: function () {
        bindBulletClicks(this, originalCount);
      },
      paginationUpdate: function () {
        bindBulletClicks(this, originalCount);
      },
    },
  });

  function bindBulletClicks(swiper, count) {
    const bullets = document.querySelectorAll('.p-top-pickup .swiper-pagination .swiper-pagination-bullet');
    bullets.forEach((bullet, i) => {
      bullet.onclick = () => {
        swiper.slideToLoop(i);
      };
    });
  }
}

  if (document.querySelector('.p-single')) {
    const relatedSlider = new Swiper('.js-related-slider', {
      modules: [Controller, Navigation, Autoplay, Pagination],
      slidesPerView: 'auto',
      loop: true,
      speed: 800,
      allowTouchMove: true,
      centeredSlides: true,
      spaceBetween: 24,
      autoHeight: false,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      navigation: {
        prevEl: '.js-related-slider .js-swiper-button-prev',
        nextEl: '.js-related-slider .js-swiper-button-next',
      },
      pagination: {
        el: '.l-related .swiper-pagination',
        clickable: true,
      },
    });
  }
}
